import { FC } from "react";
import { Text } from "@chakra-ui/react";
import { useScheduledIntervalChange } from "~/hooks/useScheduledIntervalChange";
import { BellIcon02 } from "~/icons";
import { Trans } from "~/utils/i18next";
import { BannerContainer } from "./BannerContainer";

export const ScheduledIntervalChangeBanner: FC = () => {
  const {
    conversationalInterval,
    conversationalUpcomingInterval,
    currentPeriodEndFormatted,
    hasActivePartnerTrial,
  } = useScheduledIntervalChange();

  if (!conversationalUpcomingInterval || !conversationalInterval) return null;
  if (hasActivePartnerTrial) return null;

  return (
    <BannerContainer>
      <BellIcon02 h={4} w={4} mt="2px" />
      <Text variant="th-body3">
        <Trans
          i18nKey="planSelect.scheduledIntervalChangeBanner.content"
          values={{
            currentInterval: conversationalInterval,
            scheduledInterval: conversationalUpcomingInterval,
            currentPeriodEndFormatted,
          }}
        />
      </Text>
    </BannerContainer>
  );
};
